<script>
  import { createEventDispatcher } from "svelte";
  import { init, _ } from "svelte-i18n";
  import PubSub from "pubsub-js";

  export let tags = [];
  export let showMore = false;

  let className = "";
  export { className as class };

  const tagSelected = (ev, tag) => {
    console.log("checked tag:" + tag.term_id);

    tag.selected = !tag.selected;
    ev.target.classList.toggle("selected");

    // dispatch("tagSelected", { tag });

    onSelectTag();
  };

  const onSelectTag = (ev) => {
    const selectedTags = tags.filter((t) => t.selected).map((t) => t.term_id);
    console.log(selectedTags);

    //tags = tags; // reload category array, refreshes category view

    PubSub.publish("TAG_FILTER_CHANGED", { selectedTags });
  };
</script>

<div
  id="woocommerce_product_tag_cloud-1"
  class="widget woocommerce widget_product_tag_cloud {className}"
>
  <span class="gamma widget-title">{$_("product_tags.Product tags")}</span>
  <div class="tagcloud" class:showMore>
    {#each tags as tag}
      <a
        href="#"
        class="tag-cloud-link tag-link-{tag.term_id} {tag.selected
          ? 'selected'
          : ''}"
        style="font-size: 8pt;"
        aria-label="{tag.name} (1 proizvod)"
        on:click|preventDefault={(ev) => tagSelected(ev, tag)}>{tag.name}</a
      >
    {/each}
  </div>
  <span
    on:click={() => {
      showMore = !showMore;
    }}
    class="more-less"
  >
    <svg
      class:showMore
      enable-background="new 0 0 48 48"
      height="48px"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 48 48"
      width="48px"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      ><g id="Layer_4"
        ><polygon
          fill="#ffffff"
          points="11.849,29.003 12.923,30.077 12.928,30.072 13.997,31.143 23.996,21.144 34.004,31.15    36.15,29.001 36.148,28.998 36.15,28.996 25.176,18.022 25.184,18.015 24.017,16.85 24.01,16.856 24.003,16.85 23.483,17.369    23.479,17.364 11.849,28.993 11.854,28.998  "
        /><path
          d="M24,0C10.745,0,0,10.745,0,24s10.745,24,24,24s24-10.745,24-24S37.255,0,24,0z M24,44   C12.954,44,4,35.046,4,24S12.954,4,24,4s20,8.954,20,20S35.046,44,24,44z"
          fill="#ffffff"
        /></g
      ></svg
    >

    <!-- <img
      class:showMore
      alt={`show ${showMore ? "less" : "more"} tags`}
      src=""
    /> -->
  </span>
</div>

<style>
  .widget_product_tag_cloud .tagcloud {
    overflow: hidden;
    max-height: 64px;
  }
  .widget_product_tag_cloud .tagcloud.showMore {
    max-height: initial;
  }
  .widget_product_tag_cloud .tagcloud a.selected {
    background-color: #a8b324;
    color: #fff;
  }

  .more-less svg.showMore {
    transform: rotate(0deg);
  }

  .more-less svg {
    transform: rotate(180deg);
    max-width: 24px;
    max-height: 24px;
    margin-bottom: 10px;
  }
</style>
